import { Children, Fragment, cloneElement, isValidElement } from 'react';
import type { CSSProperties, ElementType, ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface StaggerProps {
  children: ReactNode;
  stagger?: number;
  baseDelay?: number;
  className?: string;
  as?: ElementType;
}

// Fragments and text nodes are passed through untouched — only real elements can receive the injected className/style.
export function Stagger({
  children,
  stagger = 90,
  baseDelay = 40,
  className,
  as: Tag = 'div',
}: StaggerProps) {
  const items = Children.map(children, (child, index) => {
    if (!isValidElement<{ className?: string; style?: CSSProperties }>(child)) return child;
    if (child.type === Fragment) return child;
    const delay = baseDelay + index * stagger;
    return cloneElement(child, {
      className: cn(child.props.className, 'animate-fade-in'),
      style: { ...(child.props.style ?? {}), animationDelay: `${delay}ms` },
    });
  });

  return <Tag className={className}>{items}</Tag>;
}
